import { toast } from 'sonner';

import { customerApi } from '../../lib/customerApi.js';

/**
 * Download a portal PDF. The endpoints require the bearer header (so a plain
 * <a href> won't work) — fetch as a blob via the authed client, then trigger a
 * client-side download. On failure, surface a toast (errorMessage is passed in
 * by the caller so it stays i18n-correct) and never leak the object URL.
 */
export async function downloadPortalPdf(path: string, filename: string, errorMessage: string): Promise<void> {
  try {
    const r = await customerApi().get(path, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data as Blob);
    try {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      URL.revokeObjectURL(url);
    }
  } catch {
    toast.error(errorMessage);
  }
}
